import * as types from './mutation-types'
import * as authTypes from '../authentication/mutation-types'
import userService from '../../services/user'
import { createServiceCall } from '../actionsUtil'

export const getUserData = createServiceCall({
  mainAction: types.GET_USER_DATA_REQUEST,
  serviceFunction: userService.getUserData,
  successAction: types.GET_USER_DATA_SUCCESS,
  successDataProperty: '',
  failureAction: types.GET_USER_DATA_FAILURE
})
